let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("luCgO")).then(() => parcelRequire('lGDQJ'));